module.exports = __webpack_public_path__ + "static/media/icons8-linked-in.5100826d.svg";